import React, { useState } from "react";
import Nav from "../components/Nav";
import AboutImg from "../assets/about-image.png";
import DividerImg from "../assets/2nd-arrow.svg";
import Folder from "../assets/folder-icon.png";
import "./Home.css";
import Footer from "../components/Footer";
import DividerImg2 from "../assets/3rd-arrow.svg";
import Modal from "../components/Modal"; // ✅ import modal
import { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import eclaire from "../assets/eclaire.png";
import AboutIcon from "../assets/about-icon.png";
import ProjectsIcon from "../assets/projects-icon.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import HeroLeftImg from "../assets/left-hero-img.svg";
import HeroRightImg from "../assets/right-hero-img.svg";
import TitleDividerImg from "../assets/title-divider.svg";
import swmigrants from "../assets/swmigrants.png";



gsap.registerPlugin(ScrollTrigger);


const Home = () => {
  const [activeProject, setActiveProject] = useState(null); // now stores full project

  useEffect(() => {
    // Fade + slide in sections
    gsap.utils.toArray("section").forEach((section) => {
      gsap.fromTo(
        section,
        { opacity: 0, y: 80 },
        {
          opacity: 1,
          y: 0,
          duration: 1.2,
          ease: "power3.out",
          scrollTrigger: {
            trigger: section,
            start: "top 80%",
            toggleActions: "play none none reverse",
          },
        }
      );
    });
  
    // Hero text animation on load
    gsap.fromTo(
      ".hero-text h1",
      { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 1, delay: 0.3, ease: "power3.out" }
    );
  
    gsap.fromTo(
      ".hero-subtitle span",
      { opacity: 0, y: 20 },
      { opacity: 1, y: 0, duration: 0.6, stagger: 0.15, delay: 0.6, ease: "power3.out" }
    );
  
    gsap.fromTo(
      ".tech-item",
      { opacity: 0, y: 40, scale: 0.8 },
      {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 1.2,
        stagger: 0.2,
        scrollTrigger: {
          trigger: ".tech-stack",
          start: "top 80%",
        },
      }
    );
  }, []);
  
  
  const projects = [
    {
      id: 1,
      title: "eclaire",
      shortDescription: "French restaurant website built with React + Figma.", // ✅ short
      description:
        "A French restaurant website — designed in Figma and developed using React. Built with elegant styling, a fully responsive layout, and deployed at a custom domain.",
      website: "https://eclaire.maisaa.dev",
      previewImage: eclaire,
      figma:
        "https://www.figma.com/embed?embed_host=share&url=https://www.figma.com/proto/MzassCVqLbeOOQil0sGdF4/eclaire?scaling=scale-down",
    },
{
  id: 2,
  title: "south west womens group",
  shortDescription:
    "A community-focused website for the South West Womens Migrant Group.",
  description:
    "A website designed and developed for the South West Womens Migrant Group, providing accessible information, resources, and support for migrant women in the community.",
  website: "https://swmigrants.org",
  previewImage: swmigrants,
},
    {
      id: 3,
      title: "ar google maps for kids",
      shortDescription: "Interactive AR map concept for children.", // ✅ short
      description:
        "A playful AR navigation app designed to make maps fun and engaging for children.",
        figma: "https://www.figma.com/embed?embed_host=share&url=https://www.figma.com/proto/Q15AQ2OG8CqoJj87KUoDTO/UIUX-Group-4-1?node-id=650-4347&p=f&t=xTd1dFKiUwHpiLMP-1&scaling=min-zoom&content-scaling=fixed&page-id=650%3A2953&hide-ui=1"
      }
    
  ];
  
  return (
    <div className="home">
      <Nav />

      <section className="hero">
  <div className="hero-left">
    <img src={HeroLeftImg} alt="Left drawing" />
  </div>

  <div className="hero-center">
  <h1>maisaa</h1>
  <p className="hero-subtitle">
    <span className="line">
      <span>ux engineer</span>
      <span className="dot">•</span>
    </span>
    <span className="line">
      <span>web developer</span>
      <span className="dot">•</span>
    </span>
    <span className="line">
      <span>creative explorer</span>
    </span>
    
  </p>
 
</div>


  <div className="hero-right">
    <img src={HeroRightImg} alt="Right drawing" />
  </div>
</section>

{/* Title divider under hero */}
<div className="title-divider">
  <img src={TitleDividerImg} alt="Title Divider" />
</div>


      <section className="about" id="about">
        <div className="about-content">
          <div className="about-text">
            <h2>about me
            <img src={AboutIcon} alt="About icon" className="section-icon" />
            </h2>
            <p>
            <span className="tag-line">i build. i design. i occasionally break things (but i fix them too).</span>{" "}
  <br /><br />
  i’m a <span className="highlight-bold">web developer</span> and{" "}
  <span className="highlight-bold">UX engineer</span> with a{" "}
  <span className="highlight-bold">
    computer science (hons) degree
  </span>
  . i love bringing together design and technology to create
  websites and products that not only work smoothly but also feel
  great to use. for me, it’s all about making digital experiences
  that connect with people in a simple, thoughtful way.
</p>

          </div>
          <div className="about-image">
            <img src={AboutImg} alt="About Illustration" />
          </div>
        </div>
      </section>

      {/* Divider image */}
      <div className="divider">
        <img src={DividerImg} alt="Divider" />
      </div>

      <section className="projects" id="projects">
        <h2>projects
        <img src={ProjectsIcon} alt="Projects icon" className="section-icon" />

        </h2>

        <div className="project-list">
          {projects.map((project) => (
            <div key={project.id} className="project">
              <h3>{project.title}</h3>

              {/* clickable folder */}
              <img
                src={Folder}
                alt={project.title}
                className="project-folder"
                onClick={() => setActiveProject(project)} // ✅ open modal with project
                style={{ cursor: "pointer" }}
              />
      {/* ✅ use the actual description */}
      <p className="project-short">{project.shortDescription}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Divider image */}
      <div className="final-divider">
        <img src={DividerImg2} alt="Divider" />
      </div>

  {/* Tech Stack Section */}
<section className="tech-stack">
  <h2>tech stack</h2>

  <div className="tech-list">
    <div className="tech-item">
      <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg" alt="Figma" />
      <p>figma</p>
    </div>
    <div className="tech-item">
      <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" alt="React" />
      <p>react</p>
    </div>
    <div className="tech-item">
      <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg" alt="HTML5" />
      <p>html</p>
    </div>
    <div className="tech-item">
      <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg" alt="CSS3" />
      <p>css</p>
    </div>
    <div className="tech-item">
      <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg" alt="JavaScript" />
      <p>javascript</p>
    </div>
    <div className="tech-item">
      <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg" alt="Node.js" />
      <p>node.js</p>
    </div>
    <div className="tech-item">
      <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg" alt="Express" />
      <p>express</p>
    </div>
  </div>
</section>



      {/* ✅ Modal component */}
      <Modal
        isOpen={!!activeProject}
        onClose={() => setActiveProject(null)}
        project={activeProject}
      />

      <Footer />
    </div>
  );
};

export default Home;
